import { render, staticRenderFns } from "./ModalPreviewDocx.vue?vue&type=template&id=0644e050&scoped=true"
import script from "./ModalPreviewDocx.vue?vue&type=script&lang=js"
export * from "./ModalPreviewDocx.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewDocx.vue?vue&type=style&index=0&id=0644e050&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644e050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0644e050')) {
      api.createRecord('0644e050', component.options)
    } else {
      api.reload('0644e050', component.options)
    }
    module.hot.accept("./ModalPreviewDocx.vue?vue&type=template&id=0644e050&scoped=true", function () {
      api.rerender('0644e050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewDocx.vue"
export default component.exports